import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dummyArtifactNotice: {
    defaultMessage: 'Nothing has actually changed in C2 boards. This is a dummy notice.',
    id: 'noticeTextContent.dummyArtifactNotice',
  },
  dummyArtifactNoticeTitle: {
    defaultMessage: 'Check out this new C2 feature!',
    id: 'noticeTextContent.dummyArtifactNoticeTitle',
  },
  dummyTipsAndTricksNotice: {
    defaultMessage: 'This is a dummy tip/trick.',
    id: 'noticeTextContent.dummyTipsAndTricksNotice',
  },
  dummyWhatsNewNotice: {
    defaultMessage: "This is a dummy what's new notice.",
    id: 'noticeTextContent.dummyWhatsNewNotice',
  },
  'releaseNotes-1.0.0-description': {
    defaultMessage:
      'Enhancing performance, refining the UI, and introducing powerful new features.',
    id: 'noticeTextContent.releaseNotes-1.0.0-description',
  },
  'releaseNotes-1.0.0-section1-header': {
    defaultMessage: 'New features',
    id: 'noticeTextContent.releaseNotes-1.0.0-section1',
  },
  'releaseNotes-1.0.0-section1-item1': {
    defaultMessage:
      'Bulk actions - perform actions on multiple items at once, making workflows faster and more efficient.',
    id: 'noticeTextContent.releaseNotes-1.0.0-section1-item1',
  },
  'releaseNotes-1.0.0-section1-item2': {
    defaultMessage:
      'Customizable views - tailor your views to display the information you need, the way you want it.',
    id: 'noticeTextContent.releaseNotes-1.0.0-section1-item2',
  },
  'releaseNotes-1.0.0-section1-item3': {
    defaultMessage:
      'Improved search - find what you need faster with enhanced search capabilities.',
    id: 'noticeTextContent.releaseNotes-1.0.0-section1-item3',
  },
  'releaseNotes-1.0.0-section2-header': {
    defaultMessage: 'Improvements & fixes',
    id: 'noticeTextContent.releaseNotes-1.0.0-section2',
  },
  'releaseNotes-1.0.0-section2-item1': {
    defaultMessage: 'Performance enhancements - enjoy a faster, more responsive experience.',
    id: 'noticeTextContent.releaseNotes-1.0.0-section2-item1',
  },
  'releaseNotes-1.0.0-section2-item2': {
    defaultMessage: 'UI refinements - experience a more polished, intuitive interface.',
    id: 'noticeTextContent.releaseNotes-1.0.0-section2-item2',
  },
});

export default messages;
